module.exports = __webpack_public_path__ + "img/yellow-book.5336855a.png";